<template>
  <div id="mall" class="store-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="$t('title.mall')"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      class="store-navbar"
    >
      <template #right>
         <img src="../assets/img/mall/shop.png" class="mall_title_rank" @click="onClickRight"/>
      </template>
    </van-nav-bar>
    <!-- 分类标签栏 -->
    <div class="category-tabs">
      <van-tabs v-model="activeCategory" 
                line-height="0" 
                color="#ADADAD" 
                title-active-color="#1A1A1A" 
                title-inactive-color="#999"
                :disabled="isLoading"
                @click="onCategoryClick">
        <van-tab :name="value.id" v-for="(value,j) in allCategories" :key="j">
          <template #title>
            <div class="tab-title-wrapper">
              <img class="tab-icon" :src="value.id == activeCategory ? value.select_icon : value.icon" :alt="value.label" />
              <div class="tab-text">{{ value.label }}</div>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 内容区域 -->
    <div class="content-area">
        <div>
        <div class="section-block section-block-top">
          <div class="product-grid">
            <div class="product-item" v-for="(item, index) in list" :key="item.id || index">
              <div class="product-image">
                <!-- 头像框类型：显示用户头像 + 头像框 -->
                <div v-if="activeCategory == 0" class="avatar-frame-image">
                  <img v-if="head_image" :src="head_image" alt="User Avatar" class="user-avatar" />
                  <div v-if="isSvga(item.img)" :ref="'svga-' + index" class="svga-container"></div>
                  <img v-else :src="item.img" :alt="item.name" class="avatar-frame-overlay" />
                </div>
                <!-- 其他类型：正常显示 -->
                <template v-else>
                  <div v-if="isSvga(item.img)" :ref="'svga-' + index" class="svga-container"></div>
                  <img v-else :src="item.img" :alt="item.name" />
                </template>
              </div>
              <div class="product-info">
                <div class="product-due-date">{{ $t('column.due_date') }}</div>
                <div class="product-price">
                  {{ item.end_date }}
                </div>
                <div class="wear-button" 
                     :class="item.status != 1 ? 'status-on' : 'status-off'" 
                     @click.stop="toggleWearStatus(item)">
                  {{ item.status == 1 ? $t('other.close') : $t('other.open') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
import SVGA from "svgaplayerweb";

export default {
  data() {
    return {
      document_title: '',
      activeCategory: '1',
      isLoading: false, // 加载状态,控制查询期间禁止点击
      type_list:{
        '-2': 'Rare ID',
        '-1': 'Ride',
        '0': 'Avatar Frame',
        '1': 'Honor',
        '2': 'Profile Card',
        '3': 'Party Theme',
        '4': 'Chat Bubble'
      }, // -2靓号 -1座驾 0头像框  ﻿	
      // 所有分类  1勋章Honor 2个人资料卡Profile Card 3派对主题(背景图)Party Theme 4聊天气泡 Chat Bubble
      allCategories: [
        { id:1,name: 'honor', label: 'Honor', icon: require('@/assets/img/mall/mall_tab_icon_2_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_2_2.png') },
        { id:-1,name: 'ride', label: 'Ride', icon: require('@/assets/img/mall/mall_tab_icon_4_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_4_2.png') },
        { id:2,name: 'profile_card', label: 'Profile Card', icon: require('@/assets/img/mall/mall_tab_icon_5_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_5_2.png') },
        { id:0,name: 'avatar_frame', label: 'Avatar Frame', icon: require('@/assets/img/mall/mall_tab_icon_6_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_6_2.png') },
        { id:3,name: 'party_theme', label: 'Party Theme', icon: require('@/assets/img/mall/mall_tab_icon_7_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_7_2.png') },
        { id:4,name: 'chat_bubble', label: 'Chat Bubble', icon: require('@/assets/img/mall/mall_tab_icon_8_1.png'), select_icon:require('@/assets/img/mall/mall_tab_icon_8_2.png') }
      ],
      list:[],
      head_image: '' // 用户头像
    }
  },
  created() {
    this.loadProducts()
  },
  watch: {
    activeCategory() {
      // 监听分类变化，确保加载状态被重置
      this.isLoading = false
    }
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    loadProducts() {
      console.log('loadProducts called, category:', this.activeCategory)
      // 加载商品数据
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.isLoading = true // 开始加载，禁止点击
      console.log('Set isLoading to true')
      
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=my_items_list", {
        params: {
          user_id: uid,
          token: token,
          type: this.activeCategory
        }
      }).then(res => {
        console.log('loadProducts response:', res.data)
        if (res.data.status === 1) {
          // 处理返回的商品数据
          this.list = res.data.data.list || []
          console.log('Updated list:', this.list.length, 'items')
          // 获取用户头像（用于头像框显示）
          if (res.data.data.head_image) {
            this.head_image = res.data.data.head_image
          }
          // 播放 SVGA 动画
          this.$nextTick(() => {
            this.list.forEach((item, index) => {
              if (this.isSvga(item.img)) {
                this.playSvga(item.img, 'svga-' + index)
              }
            })
          })
        }
      }).catch(err => {
        console.error('Failed to load products:', err)
      }).finally(() => {
        // 使用 $nextTick 确保状态更新在下一个微任务中执行
        this.$nextTick(() => {
          this.isLoading = false // 加载完成，恢复点击
          console.log('Set isLoading to false')
        })
      })
    },
    onCategoryClick() {
      // 如果正在加载，阻止点击
      if (this.isLoading) {
        return
      }
      // 点击分类标签时重新查询数据
      this.loadProducts()
    },
    onClickLeft() {
      const source = this.$route.query.source ? this.$route.query.source : ''
      if (source === 'h5') {
        this.$router.go(-1)
      } else {
        window.location.href="bogolive://exit"
      }
    },
    onClickRight() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({
        path: '/mall',
        query: { uid: uid, token: token,source: 'h5', is_full: 1 }
      })
    },
    isSvga(url) {
      if (!url) return false
      const cleanUrl = url.split('?')[0].split('#')[0]
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'svga'
    },
    playSvga(url, refName) {
      if (!url || !this.isSvga(url)) return
      this.$nextTick(() => {
        const container = this.$refs[refName]
        // 处理单个元素或数组
        const targetContainer = Array.isArray(container) ? container[0] : container
        if (!targetContainer) {
          console.log('SVGA container not found:', refName)
          return
        }
        console.log('Playing SVGA:', url, 'in container:', refName)
        try {
          const player = new SVGA.Player(targetContainer)
          const parser = new SVGA.Parser()
          parser.load(url, (videoItem) => {
            if (!videoItem) {
              console.error('SVGA load failed:', url)
              return
            }
            console.log('SVGA loaded successfully:', videoItem)
            player.setVideoItem(videoItem)
            player.startAnimation()
          })
        } catch (error) {
          console.error('SVGA play error:', error)
        }
      })
    },
    playCategorySvga(category) {
      // 根据分类播放 SVGA 动画
      this.$nextTick(() => {
        this.list.forEach((item, index) => {
            if (this.isSvga(item.img)) {
            this.playSvga(item.img, 'svga-' + index)
            }
        })
      })
    },
    toggleWearStatus(item) {
      console.log('toggleWearStatus called', item, 'isLoading:', this.isLoading)
      // 确保不在加载状态
      if (this.isLoading) {
        console.log('Blocked: still loading')
        return
      }
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      const newStatus = item.status == 1 ? 0 : 1
      const title = item.status == 1 ? this.$t('mall.is_confirm_close') : this.$t('mall.is_confirm_open')
      console.log('Showing dialog with title:', title)
      Dialog.confirm({
        message: title
      }).then(() => {
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=open_close_items", {
          params: {
            user_id: uid,
            token: token,
            id: item.id,
            type: item.type,
            status: newStatus
          }
        }).then(res => {
          Toast(res.data.error)
          if (res.data.status == 1) {
             this.loadProducts()
          }
        }).catch(err => {
          Toast.fail(this.$t('mall.purchase_failed') + ' ' + err)
          console.error(err)
        })
      }).catch(() => {
        // 取消购买
      })


    }
  }
}
</script>

<style scoped>
.wear-button {
  margin-top: 8px;
  padding: 6px 12px;
  color: #fff;
  border-radius: 20px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  user-select: none;
}
.wear-button.status-on {
  background: #FF61F5;
}
.wear-button.status-off {
  background: #999999;
}
.wear-button:active {
  transform: scale(0.95);
  opacity: 0.8;
}

/* 头像框类型专用样式 */
.avatar-frame-image {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 用户头像 - 位于底层 */
.user-avatar {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  object-fit: cover;
  border-radius: 50%;
  z-index: 1;
}

/* 头像框 overlay - 位于上层 */
.avatar-frame-overlay {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 2;
}

/* SVGA 头像框 - 位于上层 */
.avatar-frame-image .svga-container {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/mall_my.vue